(() => {
  const root = document.getElementById('evolt-language-choice');
  if (!root || root.dataset.editor === 'true') return;
  const current = root.dataset.language;
  if (current !== 'sl' && current !== 'en') return;
  const key = 'evolt-language-choice-v1';
  const valid = value => value === 'sl' || value === 'en';
  const read = () => {
    try {
      const value = localStorage.getItem(key);
      if (valid(value)) return value;
    } catch (_) {}
    try {
      const cookie = document.cookie.split('; ').find(value => value.startsWith(key + '='));
      const value = cookie ? cookie.slice(key.length + 1) : null;
      return valid(value) ? value : null;
    } catch (_) { return null; }
  };
  const save = value => {
    if (!valid(value)) return;
    try { localStorage.setItem(key, value); } catch (_) {}
    try { document.cookie = key + '=' + value + '; Max-Age=31536000; Path=/; SameSite=Lax; Secure'; } catch (_) {}
  };
  document.addEventListener('click', event => {
    const link = event.target.closest('localization-form a[lang][data-value]');
    if (link) save(link.dataset.value);
  }, true);
  document.addEventListener('submit', event => {
    if (event.target === root.querySelector('form')) return;
    const input = event.target.querySelector('[name="locale_code"], [name="language_code"]');
    if (input) save(input.value);
  }, true);
  if (current === 'sl') {
    save('sl');
    try { sessionStorage.removeItem(key + '-redirect'); } catch (_) {}
    return;
  }
  const panel = root.querySelector('[data-language-panel]');
  const form = root.querySelector('form');
  if (!panel || !form) return;
  const returnTo = form.querySelector('[name="return_to"]');
  if (returnTo) returnTo.value = location.pathname + location.search + location.hash;
  const guardKey = key + '-redirect';
  const destination = location.pathname + location.search;
  const switchToSlovenian = () => {
    try { sessionStorage.setItem(guardKey, destination); } catch (_) {}
    form.querySelector('[name="language_code"]').value = 'sl';
    HTMLFormElement.prototype.submit.call(form);
  };
  root.addEventListener('click', event => {
    const button = event.target.closest('[data-language-choice]');
    if (!button) return;
    const language = button.dataset.languageChoice;
    save(language);
    panel.hidden = true;
    if (language === 'sl') switchToSlovenian();
  });
  const reconcile = () => {
    const choice = read();
    panel.hidden = true;
    if (choice === 'en') return;
    if (choice === 'sl') {
      let previous = destination;
      try { previous = sessionStorage.getItem(guardKey); } catch (_) {}
      if (previous !== destination) {
        switchToSlovenian();
        return;
      }
    }
    panel.hidden = false;
  };
  window.addEventListener('pageshow', event => {
    if (event.persisted) reconcile();
  });
  reconcile();
})();
